import BasePriceBinder from './BasePriceBinder';

export default class InputTextBinder extends BasePriceBinder {
	constructor(id, title, calculator, summaryDisplayer, priceFormatter) {
		super(id, title, calculator, summaryDisplayer, priceFormatter);
		this.baseElement = document.getElementById(this.id);
		this.isActive = this.baseElement.value !== '';
	}
	initEvents() {
		this.baseElement.addEventListener('input', (e) => {
			this.isActive = e.target.value !== '';
			this.handleChange();
		});

		this.baseElement.addEventListener('change', (e) => {
			this.isActive = e.target.value !== '';
			this.handleChange();
		});

		super.initEvents();
	}
}
